<Navbar />
    <Sidebar />
    <div v-if="is_loading" class="loading-overlay position-fixed align-items-center justify-content-center d-flex">
      <div class="spinner-container">
        <div class="custom-spinner"></div>
        <p class="loading-text">Loading audit logs...</p>
      </div>
    </div>

    <div class="page-wrapper">
      <div class="hero-section w-100">
        <div class="border rounded-4 p-2 custom-border">
          <div lass="mb-4">
            <h2 class="gradient-text fw-bold">Activity Logs</h2>
            <p class="text-muted">Monitor user actions, system events, and associated risk levels.</p>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex gap-2 mb-2">
            </div>

            <div class="d-flex gap-2 mb-2">
              <div class="dropdown">
                <button
                  class="filter-button text-dark d-flex me-2 dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  data-bs-boundary="viewport"
                  aria-expanded="false"
                >
                  <i class="fas fa-filter me-2 mt-2 fa-sm"></i> Filter
                </button>

                <div
                  class="dropdown-menu dropdown-menu-end p-3 shadow rounded-4"
                >
                  <div class="d-flex flex-wrap gap-2 mb-2">
                    <select id="user_filter" class="form-control form-control-sm filter-input">
                      <option value="">All Users</option>
                      <option v-for="user in unique_users" :key="user" :value="user">{{ user }}</option>
                    </select>

                    <select id="source_filter" class="form-control form-control-sm filter-input">
                      <option value="">Platforms</option>
                      <option v-for="source in unique_sources" :key="source" :value="source">{{ source }}</option>
                    </select>

                    <select id="risk_level_filter" class="form-control form-control-sm filter-input">
                      <option value="">All Risk Levels</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                      <option value="Critical">Critical</option>
                    </select>

                    <input type="date" id="date_from" class="form-control form-control-sm filter-input">
                    <input type="date" id="date_to" class="form-control form-control-sm filter-input">
                  </div>

                  <div class="d-flex justify-content-end gap-2">
                    <button id="reset_filters" type="button" class="upload-button btn-sm text-white box-shadow small d-flex align-items-center">Reset</button>
                    <button id="apply_filters" type="button" class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2">Apply</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card table-card">
            <div class="card-body">
              <div class="table-responsive content-table">

                <table :key="table_key" id="audit_trail_table" class="table text-xs table-striped" data-sort="true">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Full Names</th>
                      <th>Email</th>
                      <th>Platform</th>
                      <th>Date & Time</th>
                      <th>Activity description</th>
                      <th>Risk Level</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody class="text-start text-xs">
                    <tr v-for="(user, index) in audits" :key="user.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ user.user_full_names }}</td>
                      <td>{{ user.user_email }}</td>
                      <td>{{ user.source }}</td>
                      <td>{{user.date_created}}</td>
                      <td class="description-cell">{{ user.description }}</td>
                      <td>
                        <span
                          :class="['risk-level text-nowrap d-inline-block px-3 py-1 rounded-pill', (user.risk_level || user.risk_level_name || '').toLowerCase()]">
                          {{ user.risk_level || user.risk_level_name }}
                        </span>

                      </td>
                      <td>
                        <button class="btn btn-sm btn-success text-nowrap px-4" @click="go_to_page(user.page_url)">
                          View
                        </button>

                      </td>
                    </tr>
                  </tbody>
                </table>

                <div
                  v-if="pagination.num_pages > 1"
                  class="d-flex justify-content-between align-items-center mt-3"
                >
                  <span class="pagination-info">
                    Showing page {{ pagination.current_page }} of {{ pagination.num_pages }}
                    <span v-if="pagination.total">
                      (Total: {{ pagination.total }} records)
                    </span>
                  </span>

                  <div>
                    <button
                      class="btn btn-sm btn-outline-secondary me-2"
                      :disabled="!pagination.has_previous"
                      @click="previous_page"
                    >
                      Previous
                    </button>

                    <button
                      class="btn btn-sm btn-outline-secondary"
                      :disabled="!pagination.has_next"
                      @click="next_page"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
<PoweredBy/>